module.exports = __webpack_public_path__ + "static/media/archiva.d14a958d.png";